module.exports = __webpack_public_path__ + "img/www.appstore.com.9a40114a.png";